import { Text } from '@lmc/ui-kit/src/general'
import { FC } from 'react'
import { Spinner } from 'components/generic'
import styled from 'styled-components'

type FrequencyResultProps = { message?: string; isLoading?: boolean }
const FrequencyResult: FC<FrequencyResultProps> = ({ message, isLoading }) => {
  return (
    <Container>
      {isLoading && <Spinner style={{ paddingTop: 0 }} />}
      {!isLoading && <StyledText>{message}</StyledText>}
    </Container>
  )
}

const StyledText = styled(Text)`
  border: 1px;
  color: ${({ theme }) => theme.color.neutral.color4};
`

const Container = styled.div`
  border: 1px solid;
  border-color: ${({ theme }) => theme.color.neutral.color8};
  border-radius: 20px;
  padding: 24px;
`

export default FrequencyResult
